import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Button, theme } from "uikit";
import styled from "styled-components";

import { StyledRow } from "../../../../../../../../../../../components/common";

const Root = styled(StyledRow)`
	padding: 12px 24px;

	background: ${theme.colors.white};
`;

const Footer = memo<Footer.Props>(({ onCancel, onSubmit }) => {
	const { t } = useTranslation();
	return (
		<Root alignItems="center" justify="space-between" gap="10px">
			<StyledRow gap="10px" />
			<StyledRow gap="10px">
				<Button.Button
					variant="secondary"
					text={t("noCapitalized") ?? ""}
					onClick={onCancel}
				/>
				<Button.Button
					text={t("yesCapitalized") ?? ""}
					onClick={onSubmit}
				/>
			</StyledRow>
		</Root>
	);
});

declare namespace Footer {
	interface Props {
		onCancel?: () => void;
		onSubmit?: () => void;
	}
}

export default Footer;
